import { useQuery } from '@tanstack/react-query';
import { fetchHomeSummary, homeKeys } from '../api';
import { useMyProfile } from '@/features/profile/hooks/useMyProfile';

/**
 * Hook para el dashboard home. Usa la moneda preferida del usuario
 * (fallback EUR si no está configurada).
 *
 * `activityLimit` entra en la clave de caché, así que dos pantallas que pidan
 * tamaños distintos hacen **dos** consultas a `my_home_summary`, que no es
 * barata: recorre noventa días de gastos y liquidaciones de todos tus grupos y
 * convierte divisas. El límite sólo recorta la lista final, no ese trabajo. Por
 * eso quien no necesite un tamaño concreto debe llamar sin argumento y caer en
 * la clave común.
 *
 * `activo` es para quien no siempre debe pedirla —la barra lateral está montada
 * también en móvil, oculta por CSS—.
 */
export function useHomeSummary(activityLimit = 15, activo = true) {
  const { data: profile } = useMyProfile();
  const target = profile?.preferred_currency ?? 'EUR';
  return useQuery({
    queryKey: homeKeys.summary(target, activityLimit),
    queryFn: () => fetchHomeSummary(target, activityLimit),
    enabled: Boolean(profile) && activo,
    staleTime: 30_000,
  });
}
